import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1034"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.745 7.927V3.649c0-1.626-1.323-2.95-2.95-2.95s-2.95 1.324-2.95 2.95v4.278a4.178 4.178 0 0 0-1.25 2.968c0 2.316 1.885 4.2 4.2 4.2s4.2-1.884 4.2-4.2a4.176 4.176 0 0 0-1.25-2.968zm-2.95 5.768a2.803 2.803 0 0 1-2.8-2.8 2.79 2.79 0 0 1 1.002-2.126.701.701 0 0 0 .248-.534V3.649c0-.854.695-1.55 1.55-1.55s1.55.695 1.55 1.55v4.586a.7.7 0 0 0 .248.534 2.788 2.788 0 0 1 1.002 2.126c0 1.544-1.256 2.8-2.8 2.8zM7.22 5.327a.7.7 0 0 0-.7-.7H5.322l.599-1.038a.702.702 0 0 0-.256-.957.703.703 0 0 0-.957.257l-.599 1.037-.599-1.037a.702.702 0 0 0-.957-.257.702.702 0 0 0-.256.957l.599 1.038H1.698a.7.7 0 1 0 0 1.4h1.198l-.599 1.038a.7.7 0 0 0 1.213.7l.599-1.038.599 1.038a.7.7 0 1 0 1.213-.7l-.599-1.038H6.52a.7.7 0 0 0 .7-.7z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M11.245 9.303V7.175a.5.5 0 0 0-1 0v2.141a1.755 1.755 0 0 0 .522 3.431 1.754 1.754 0 0 0 .478-3.444z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }